var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4D9D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.353 30V28.9773L19.1939 24.7727C19.6446 24.2803 20.0159 23.8523 20.3075 23.4886C20.5992 23.1212 20.8151 22.7765 20.9553 22.4545C21.0992 22.1288 21.1712 21.7879 21.1712 21.4318C21.1712 21.0227 21.0727 20.6686 20.8757 20.3693C20.6825 20.0701 20.4174 19.839 20.0803 19.6761C19.7431 19.5133 19.3643 19.4318 18.9439 19.4318C18.4969 19.4318 18.1068 19.5246 17.7734 19.7102C17.4439 19.892 17.1882 20.1477 17.0064 20.4773C16.8284 20.8068 16.7393 21.1932 16.7393 21.6364H15.3984C15.3984 20.9545 15.5556 20.3561 15.87 19.8409C16.1844 19.3258 16.6125 18.9242 17.1541 18.6364C17.6996 18.3485 18.3113 18.2045 18.9893 18.2045C19.6712 18.2045 20.2753 18.3485 20.8018 18.6364C21.3284 18.9242 21.7412 19.3125 22.0405 19.8011C22.3397 20.2898 22.4893 20.8333 22.4893 21.4318C22.4893 21.8598 22.4117 22.2784 22.2564 22.6875C22.1049 23.0928 21.8397 23.5455 21.4609 24.0455C21.0859 24.5417 20.5651 25.1477 19.8984 25.8636L17.2848 28.6591V28.75H22.6939V30H15.353ZM24.5178 27.6136V26.4545L29.6314 18.3636H30.4723V20.1591H29.9041L26.0405 26.2727V26.3636H32.9268V27.6136H24.5178ZM29.995 30V27.2614V26.7216V18.3636H31.3359V30H29.995Z",
    fill: "#E34B31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/24.f1a6f7bd9e25f280aabd5dc95892c239.svg";
export { ForwardRef as ReactComponent };